export default "__VITE_ASSET__bfJvSr9Y__"